import { mergeDeep } from '@/helpers/utils'
import { LandingScreenSchema, LandingComponentsConfig } from '@/modules/Landing/instances/@types/landing-types'
import alertGiftPng from '@/assets/landing/alert-gift.png'

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		{},
		{
			order: ['LandingAlert', 'LandingTitleExtended', 'LandingAgeGrid'],

			components: {
				LandingAlert: ({ $t }): LandingComponentsConfig['LandingAlert'] => ({
					text: $t('female_yoga.pages.landing.alert_text'),
					icon: alertGiftPng,
					backgroundColor: 'var(--Fill-Accent-16)',
					customStyles: {
						marginTop: 'var(--size-20)',
					},
				}),
				LandingTitleExtended: ({ $t }): LandingComponentsConfig['LandingTitleExtended'] => ({
					title: $t('pages.landing.tai_chi.age_title'),
					note: $t('female_yoga.pages.landing.quiz'),
				}),
			},
		},
	]

	return mergeDeep([...schemas], extensionSchema)
}
